export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0069.09aa5a9a.webp";